<script>
  import { Link } from '@inertiajs/svelte'

  let { label, value, delta, highlight = false, href } = $props()

  const deltaTone = $derived(typeof delta === 'number' && delta < 0 ? 'text-error' : 'text-success')
</script>

{#snippet content()}
  <div class="stat" class:bg-warning={highlight} class:rounded-box={highlight}>
    <div class="stat-title">{label}</div>
    <div class="stat-value text-2xl">{value}</div>
    {#if delta !== undefined && delta !== null}
      <div class="stat-desc {deltaTone}">{delta > 0 ? '+' : ''}{delta}</div>
    {/if}
  </div>
{/snippet}

{#if href}
  <Link {href} class="block hover:opacity-80">{@render content()}</Link>
{:else}
  {@render content()}
{/if}
